module.exports = __webpack_public_path__ + "static/media/mg.93ad6482.svg";